import { useEffect } from "react";

const usePreventPageUnload = (shouldPrevent) => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldPrevent) {
        event.preventDefault();
        event.returnValue = ""; // Required for modern browsers to show the dialog
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldPrevent]);
};

export default usePreventPageUnload;
